import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import * as appSetting from '../app-setting/app-setting.actions';


@Injectable()
export class AppSettingEffects {



  constructor(private actions$: Actions ,private translate:TranslateService,@Inject(DOCUMENT) private document: Document ) {}

 
  langChange$ = createEffect(()=>this.actions$.pipe(
    ofType(appSetting.updateAppLang),
    map((v)=>{
      localStorage.removeItem('lang');
      localStorage.setItem('lang',v.Lang);
      this.translate.use(v.Lang);
     
      if(v.Lang ==='ar'){
        this.document.dir ='rtl';
        this.document.body.classList.add('ar')

      }else {
        this.document.dir ='ltr';
        this.document.body.classList.remove('ar')

      }
      return appSetting.updateAppLangSuccess({Lang:v.Lang});
    })
  ))
   

}
